import React, { Component } from 'react';
import StudentCourseManagementButtons from './StudentCourseManagementButtons';

class StudentCourseManagement extends Component {
    render() {
        return (
            <div className="container-fluid">
                <div className="container">
                    <StudentCourseManagementButtons />
                </div>
            </div>
        );
    }
}

export default StudentCourseManagement;